import React from "react";
import { COLORS, SKILLS } from "../data/profile";
import { useLang, t } from "../LanguageContext";

export default function SkillsTab() {
  const { lang } = useLang();

  const SECTIONS = [
    { title: { en: "Strong", fr: "Points Forts" }, items: SKILLS.strong, color: "#2D5F2D", bg: "#E8F5E8", border: "#B8D4B8" },
    { title: { en: "Moderate", fr: "Modéré" }, items: SKILLS.moderate, color: "#8B6914", bg: "#FFF8E1", border: "#E8D88C" },
    { title: { en: "Gaps I Will Tell You About", fr: "Lacunes que je vous signalerai" }, items: SKILLS.gaps, color: "#8B4D4D", bg: "#FDE8E8", border: "#D4A8A8" },
  ];

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(20px, 5vw, 24px)", marginBottom: 6, color: COLORS.text }}>
        {lang === "en" ? "Capabilities" : "Compétences"}
      </h2>
      <p style={{ fontSize: 13, color: COLORS.muted, marginBottom: 24, lineHeight: 1.6 }}>
        {lang === "en"
          ? "Honest self-assessment. If I'm not the right fit, I'd rather you know upfront."
          : "Auto-évaluation honnête. Si je ne suis pas le bon profil, je préfère que vous le sachiez d'emblée."}
      </p>

      {SECTIONS.map((section, i) => (
        <div key={i} style={{ marginBottom: 22 }}>
          <h3
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: section.color,
              textTransform: "uppercase",
              letterSpacing: 1.5,
              marginBottom: 10,
            }}
          >
            {t(section.title, lang)}
          </h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
            {section.items.map((item, j) => (
              <span
                key={j}
                style={{
                  background: section.bg,
                  color: section.color,
                  padding: "7px 12px",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 500,
                  border: `1px solid ${section.border}`,
                  lineHeight: 1.3,
                }}
              >
                {t(item, lang)}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
